import { render, staticRenderFns } from "./MessageRichArea.vue?vue&type=template&id=d0c717de&scoped=true&"
import script from "./MessageRichArea.vue?vue&type=script&lang=js&"
export * from "./MessageRichArea.vue?vue&type=script&lang=js&"
import style0 from "./MessageRichArea.vue?vue&type=style&index=0&id=d0c717de&lang=less&scoped=true&"
import style1 from "./MessageRichArea.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0c717de",
  null
  
)

export default component.exports